import React from 'react';
import { Navigate } from 'react-router-dom';
import withPermission from '../../utils/withPermission';
import permissionTypes from '../../components/atoms/permissionsGate/permissionTypes';
import FormTemplate from '../../components/templates/formTemplate/formTemplate';
import ListTablePage from '../../components/templates/listTableTemplate/listTableTemplate';
import TabPage from '../../components/templates/tabPage/tabPage';
import viewAppCategories from '../../config/viewAppCategories';
import viewSportsRoomContentForm from '../../config/viewSportsRoomContentForm';
import viewSportRoomContent from '../../config/viewSportRoomContent';
import viewAppSportsRoomCanvas from '../../config/viewAppSportsRoomCanvas';
import viewAppSportRoomCustomization from '../../config/viewAppSportRoomCustomization';
import viewAppTransactions from '../../config/viewAppTransactions';
import viewManualProvider from '../../config/viewManualProvider';
import oculusInAppPurchasesProvider from '../../config/viewOculusInAppPurchasesProvider';
import viewSportRoomManualProviders from '../../config/viewSportRoomManualProviders';
import viewSportRoomConfig from '../../config/viewSportRoomConfig';
import viewAppSpaceHomeForm from '../../config/viewAppSpaceHomeForm';
import viewAppSportRoomBlackouts from '../../config/viewAppSportRoomBlackouts';
import viewAppSportRoomBlackoutsEdit from '../../config/viewAppSportRoomBlackoutsEdit';
import viewAppBlackoutsPostalCodes from '../../config/viewAppBlackoutsPostalCodes';
import viewBlackoutsPostalCodesEdit from '../../config/viewBlackoutsPostalCodesEdit';
import viewTagsEditForm from '../../config/viewTagsEditForm';
import viewAppTagsBlackLabel from '../../config/viewAppTagsBlackLabel';
import viewAppThirdPartyAuthProvider from '../../config/viewAppThirdPartyAuthProvider';
import viewTeamsBlackouts from '../../config/viewTeamsBlackouts';

export const sportRoomRoutes = [
  {
    path: 'categories/:configName?',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <ListTablePage
        configFile={viewAppCategories}
        withSessionVariables={['appId', 'configName']}
      />
    ),
  },
  {
    path: 'canvas/:configName?',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <FormTemplate configFile={viewAppSportsRoomCanvas} />
    ),
  },
  {
    path: 'content/:configName/:contentId',
    handle: { changeAppRedirectTo: 'content/:configName?' },
    element: withPermission(
      [permissionTypes.XTADIUM],
      <FormTemplate configFile={viewSportsRoomContentForm} />
    ),
  },
  {
    path: 'content/:configName?',
    handle: { changeAppRedirectTo: 'content/:configName?' },
    element: withPermission(
      [permissionTypes.XTADIUM],
      <ListTablePage
        configFile={viewSportRoomContent}
        withSessionVariables={['appId', 'configName']}
      />
    ),
  },
  {
    path: 'transactions',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <TabPage configFile={viewAppTransactions} />
    ),
  },
  {
    path: 'providers/:providerId',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <ListTablePage
        configFile={viewManualProvider}
        withSessionVariables={['appId', 'configName']}
      />
    ),
  },
  {
    path: 'providers',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <ListTablePage
        configFile={viewSportRoomManualProviders}
        withSessionVariables={['appId', 'configName']}
      />
    ),
  },
  {
    path: 'skus',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <ListTablePage
        configFile={oculusInAppPurchasesProvider}
        withSessionVariables={['appId', 'configName']}
      />
    ),
  },
  {
    path: 'config',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <ListTablePage
        configFile={viewSportRoomConfig}
        withSessionVariables={['appId', 'configName']}
      />
    ),
  },
  {
    path: 'home',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <FormTemplate configFile={viewAppSpaceHomeForm} />
    ),
  },
  {
    path: 'customization',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <FormTemplate configFile={viewAppSportRoomCustomization} />
    ),
  },
  {
    path: 'blackouts/:blackoutId',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <FormTemplate configFile={viewAppSportRoomBlackoutsEdit} />
    ),
  },
  {
    path: 'blackouts',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <ListTablePage
        configFile={viewAppSportRoomBlackouts}
        withSessionVariables={['appId', 'configName']}
      />
    ),
  },
  {
    path: 'postalgroups/:groupId',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <FormTemplate configFile={viewBlackoutsPostalCodesEdit} />
    ),
  },
  {
    path: 'postalgroups',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <ListTablePage configFile={viewAppBlackoutsPostalCodes} />
    ),
  },
  {
    path: 'tags/:id',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <FormTemplate configFile={viewTagsEditForm} />
    ),
  },
  {
    path: 'tags',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <ListTablePage configFile={viewAppTagsBlackLabel} />
    ),
  },
  {
    path: 'thirdPartyAuth',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <FormTemplate configFile={viewAppThirdPartyAuthProvider} />
    ),
  },
  {
    path: 'teamblackouts/:teamId',
    element: withPermission(
      [permissionTypes.XTADIUM],
      <FormTemplate configFile={viewTeamsBlackouts} />
    ),
  },
  {
    index: true,
    element: <Navigate to="home" replace />,
  },
];